import { TypeReportReceived } from "lib/enums/reportType.enum"

export const REPORT_TYPES = [
  {
    name: "Reporte IVA",
    id: 5,
    type: "iva-report",
    key: "iva",
  },
  {
    name: "Reporte RENTA",
    id: 6,
    type: "renta-report",
    key: "renta",
  },
  {
    name: "Libro de Compras",
    id: 7,
    type: "libro-report",
    key: "libro",
  },
  {
    name: "Reporte Anual",
    id: 4,
    type: "anual-report",
    key: "anual",
  },
  {
    name: "Reporte Simple",
    id: 1,
    type: "state-types-documentDate-receptionDate",
    key: "simple",
  },
  /*     {
        name: "Impuestos",
        id: 2,
        type: "year-month",
        key: "tax"
    },  
    {
        name: "ATS",
        id: 3,
        type: "year-month",
        key: "ats"
    },  */
]

export const RECEIVED_REPORT_TYPES = [
  {
    name: "TEMPLATE COSTUMER DELIVERED WHT CERTIFICATES",
    key: "simple",
    reportType: TypeReportReceived.SIMPLE,
  },
  {
    name: "XL6 ACCOUNT RECEIVABLE WHT",
    key: "accounting",
    reportType: TypeReportReceived.CONTABILIZACION,
  },
]

export const RETENTION_REPORT_TYPES = [
  {
    name: "Reporte por Estados",
    id: 1,
    type: "state-documentDate-receptionDate",
    key: "state",
  },
  {
    name: "Reporte por Contabilizar",
    id: 2,
    type: "documentDate-receptionDate",
    key: "retention",
  },
  {
    name: "Reporte Contabilizado",
    id: 3,
    type: "documentDate-receptionDate",
    key: "accounting",
  },
  {
    name: "Reporte reclamo de montos",
    id: 4,
    type: "documentDate-receptionDate",
    key: "reclaim",
  },
]

export const REPORT_CONDITIONS_IDS = [5, 6]
export const RETENTION_REPORT_CONDITIONS_IDS = [2, 5, 27, 4, 24]
export const REPORT_TYPES_IDS = [1, 8]
